import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { description_min_rows, MAX_LENGTH_VALIDATOR_KEY, REQUIRED_VALIDATOR_KEY } from '@pt/pt-models';
import * as DocumentsUtils from '../documents/utils/validator-generator';
import { ValidatorGenerator } from '../documents/utils/validator-generator';

@Component({
  selector: 'pt-validate-request-dialog',
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ title | async }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <p [innerHTML]='message | async'></p>
      <p [innerHTML]='info | async'></p>
      <form [formGroup]="formGroup">
        <pt-input-text
          [controlName]='"name"'
          formControlName='name'
          [label]="'LABELS.NAME' | translate"
          [validators]='[REQUIRED, MAX_LENGTH]'>
        </pt-input-text>
        <pt-input-text-area
          [minRow]='descriptionMinRows'
          [inputId]='"description"'
          formControlName='description'
          [label]="'LABELS.DESCRIPTION' | translate"
        ></pt-input-text-area>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]="formGroup.invalid"
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>

      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>

    </div>
  `,
  styles: [``]
})
export class ValidateRequestDialogComponent {
  public title: Observable<string>;
  public message: Observable<string>;
  public info: Observable<string>;
  public REQUIRED = ValidatorGenerator.generateWidgetValidator(REQUIRED_VALIDATOR_KEY);
  public MAX_LENGTH = DocumentsUtils.ValidatorGenerator.generateWidgetValidator(MAX_LENGTH_VALIDATOR_KEY,[128]);

  public formGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    description: new FormControl(null),
  })
  protected readonly descriptionMinRows = description_min_rows;

  constructor(public activeModal: NgbActiveModal, private translateService: TranslateService) {
  }

  run(title: string, message: string, info?: string) {
    this.title = this.translateService.stream(title);
    this.message = this.translateService.stream(message);
    if (info) {
      this.info = this.translateService.stream(info);
    }
  }

  confirm() {
    const request: ValidateDocumentRequest = this.formGroup.getRawValue();
    this.activeModal.close(request);
  }
}

